import moment from "moment";
import { useTranslation } from "react-i18next";

import { FAIRGATE_LOGO } from "@constants/assets";
import { dprTerms, legalTerms } from "@constants/urls";
import { useAppMode } from "@contexts/app-mode";
import { DateFormats } from "@enums/shared.enum";

export default function Footer() {
  const { t } = useTranslation();
  const { isKioskMode } = useAppMode();
  return (
    <div className="footer fg-footer-block" data-testid={"footer-test"}>
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="d-flex align-items-center flex-column position-relative">
              <img
                src={FAIRGATE_LOGO}
                className="float-md-end fg-footer-logo text-center d-flex d-md-block mx-auto mt-2"
                alt="Fairgate logo"
                data-testid="footer-logo"
              />
              <p className="mt-2">
                {t("footerContent", {
                  year: moment().format(DateFormats.Y),
                })}
              </p>
              {!isKioskMode && (
                <ul className="navbar-nav mb-2 flex-row align-items-center justify-content-center justify-content-md-start">
                  <li className="nav-item">
                    <a
                      className="nav-link border-end px-2 py-1"
                      href={dprTerms}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {t("fairgatessGDPRTerms")}
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link px-2 py-1"
                      href={legalTerms}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {t("fairgatessLegalTerms")}
                    </a>
                  </li>
                </ul>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
